/**
 * Expected rookie intake for each upcoming draft. Edit this file to adjust it.
 *
 * Rookies usually take two or three picks in round 1 of the league draft, but
 * we don't know who, so round 1 shows placeholders ("Rookie RB1") at these
 * picks. `positions` lists the position of each placeholder, in pick order.
 *
 * Refresh this twice a year: after bowl season (mocks settle) and after the NFL
 * draft in late April, when the real class is known. A year with no entry
 * falls back to `DEFAULT_POSITIONS`.
 *
 * Seeded May 2026 from three early first-round mocks of the 2027 NFL draft
 * (CBS 4/26, SI 5/4, FantasyPros 5/10). They put about 2 RBs and 3-6 WRs in
 * the NFL's first round (plus 5-7 QBs and 1-2 TEs), roughly one RB per two WRs.
 * No mock covers round 2.
 */

/** Round 1 picks that rookies take, best prospect first. */
export const ROOKIE_PICK_SLOTS = [3, 7, 10];

export const DEFAULT_POSITIONS = ['RB', 'WR', 'WR'];

export const ROOKIE_INTAKE = {
    2027: {
        positions: ['RB', 'WR', 'WR'],
        note: 'CBS 4/26, SI 5/4, FantasyPros 5/10: ~2 RB and 3-6 WR in NFL round 1.',
    },
    // Only one 2028 mock exists so far (Walter Football, 10/31: 2 WR, 1 TE, 0 RB in the
    // first 16 picks), so this is a low-confidence guess.
    2028: {
        positions: ['RB', 'WR', 'WR'],
        note: 'Walter Football 10/31 only; low confidence.',
    },
};

/**
 * The round 1 placeholders for a draft year, numbered per position
 * (RB1, WR1, WR2, ...). Extra positions beyond the available slots are ignored.
 */
export function rookiePlaceholdersFor(
    year,
    intake = ROOKIE_INTAKE,
    slots = ROOKIE_PICK_SLOTS,
    defaults = DEFAULT_POSITIONS
) {
    const positions = (intake[year] && intake[year].positions) || defaults;
    const seen = {};
    return positions.slice(0, slots.length).map((position, i) => {
        seen[position] = (seen[position] || 0) + 1;
        return { pick: slots[i], position, label: `Rookie ${position}${seen[position]}` };
    });
}
